$(function(){

	if($('.home').length) {
		//ロゴアニメーション
		var animation = lottie.loadAnimation({
			container: document.getElementById('lottie'),
			path: '/wp/wp-content/themes/saisho/assets/img/home/saishoGroup-animation.json',
			renderer: 'svg',
			loop: false,
			autoplay: false,
			name: "saisho",
		});
		setTimeout(function () {
			lottie.play('saisho');
			animation.onComplete = () => {
				// 任意の処理を記述する
				$('body').addClass("complete");
				// console.log('終わった');
				// logo.classList.add("complete");
			}
		}, 1000);

		//背景画像パララックス 上
		const elem_up = document.querySelector(".parallax_up");
		if (elem_up !== null) {
			let target = document.getElementsByClassName("parallax_up");
				let parallaxConfig = {
					delay: 0, // スクロール止めてから動く秒数
					orientation: "up", // 動く方向
					scale: 1.3, // 動く大きさ
					overflow: true,
				};
			const parallax_instance = new simpleParallax(target, parallaxConfig);
		}

		//採用エリア 背景黒に
		jQuery(window).scroll(function() {
			let scrollTop = jQuery(window).scrollTop(); // スクロール上部の位置
			let areaTop = jQuery(".recruit_area").offset().top; // 対象エリアの上部の位置
			let areaBottom = areaTop + jQuery(".recruit_area").innerHeight(); // 対象エリアの下部の位置
			if (scrollTop > areaTop && scrollTop < areaBottom) {
				jQuery("body").addClass("active_black"); // スクロールが対象エリアに入った場合
			} else {
				jQuery("body").removeClass("active_black"); // スクロールが対象エリアから出ている場合
			}
		});
	}

});